import { Injectable } from '@angular/core';
import { En } from './en';

@Injectable({
  providedIn: 'root'
})
export class LangService {

	/**
	 * the default language to be used
	 */
	public default = "en";
	protected lang = {};

	constructor() {
		this.setLang();
	}

	/**
	 * set the language to be used
	 * @param lang
	 */
	setLang(lang: string = 'en') {
		if (lang === 'en') {
			this.lang = En;
		}
	}

	/**
	 * return string if it is available on language list
	 * @param key the key of language to use
	 */
	getLang(key, vars:any = null) {
		if (typeof this.lang[key] != 'undefined') {
			let str = this.lang[key];
			if(vars && typeof vars == 'object'){
				let objKeys = Object.keys(vars);
				objKeys.forEach(varkey => {
					str = str.replace('{'+varkey+'}', vars[varkey]);
				});
			}
			return str;
		} else {
			return 'undefined language'
		}
	}

	trans(string: string = '', params: object = {}){
		let objKeys = Object.keys(params);
		objKeys.forEach(key => {
			let val = params[key];
			string = string.replace("%"+key+"%", val);
		});
		return string;
	}
}
